import ApiService from "./Api.service.js";

class CheckService extends ApiService {
  createArchiveCheck(payload) {
    return this.resource.post(`checks/archives`, payload);
  }
  deleteArchiveCheck(archiveId) {
    return this.resource.delete(`checks/archives/${archiveId}/lessons`);
  }
  getArchivesCheckPerUserLesson(lessonId) {
    return this.resource.get(`checks/archives/${lessonId}/lessons`);
  }

  createLinkCheck(payload) {
    return this.resource.post(`checks/links`, payload);
  }
  deleteLinkCheck(linkId) {
    return this.resource.delete(`checks/links/${linkId}/lessons`);
  }
  getLinksCheckPerUserLesson(lessonId) {
    return this.resource.get(`checks/links/${lessonId}/lessons`);
  }

  createLessonCheck(payload) {
    return this.resource.post(`checks/lessons`, payload);
  }
  deleteLessonCheck(lessonId) {
    return this.resource.delete(`checks/lessons/${lessonId}`);
  }
  getLessonsCheckPerUserLesson(lessonId) {
    return this.resource.get(`checks/lessons/${lessonId}`);
  }

  getModuleChecks(moduleId) {
    return this.resource.get(`checks/modules/${moduleId}`);
  }

  exportModuleChecks(moduleId) {
    return this.resource.get(`checks/modules/${moduleId}/export`, {
      responseType: 'blob'
    });
  }
}

export default new CheckService("checks");



// WEBPACK FOOTER //
// ./src/services/axios/check.service.js